export default __webpack_public_path__ + "static/media/dreamstime_s_23278565.17e23b89.jpg";